import axios from 'axios';
import { IAuthPayload, IAuthResponse } from 'entities/Auth/Auth.models';

const basePath = '/auth';

export const authService = {
  login: (payload: IAuthPayload): Promise<IAuthResponse> => axios.post(`${basePath}`, payload),
  refreshToken: (refreshToken: string): Promise<IAuthResponse> => axios.put(`${basePath}`, { refreshToken }),
};
